<template>
  <SectionWrapper sectionId="newsList">
    <SectionContainer>
      <ContentContainer>
        <div class="news_container">
          <NewsCard v-for="(news, index) in newsList" :key="index"
                         class="news_item"
                         :imgSrc="news['media:thumbnail']"
                         :title="news.title"
                         :link="news.link"
                         :publishIsoDate="news.isoDate" />
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
// import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
import NewsCard from '../atoms/NewsCard'
import { News as NewsFunction } from '../../functions/news'

export default {
  name: 'newsList',
  components: {
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    NewsCard
  },
  data () {
    return {
      headingData: {
        img: require('@/assets/images/all_txt.svg'),
        text: 'news'
      },
      newsList: []
    }
  },
  async mounted () {
    const newsList = await NewsFunction.getAll()
    this.newsList = newsList.sort((a, b) => {
      if (a.isoDate === b.isoDate) return 0
      return a.isoDate > b.isoDate ? -1 : 1
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.news {
  &_container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @include bpOnlySp() {
      flex-direction: column;
      align-items: center;
    }
  }
  &_item {
    width: 280px;
    padding: 10px;
  }
  &_link {
    @include bpOnlyPc() {
      font-size: 20px;
    }
    @include bpOnlySp() {
      font-size: 15px;
    }
    text-align: right;
    font-weight: bold;
    line-height: 1.4;
    letter-spacing: 0.1em;
    margin-bottom: 20px;
  }
}
</style>
